export function getFileExtension(fileName?: string): string {
  if (!fileName) return ''
  return fileName.split('.').pop() || ''
}
